<template>
  <div class="container wc-container">
    <h3 style="margin-bottom:30px;">Audio Participants</h3>
    <Button type="primary" @click="exportTable()">
      <Icon type="ios-download-outline"></Icon>Export source data
    </Button>
    <Table
      :loading="loading"
      width="100%"
      height="500"
      border
      :columns="columns"
      :data="attData"
      size="small"
      ref="table"
    ></Table>
  </div>
</template>
<script>
import moment from "moment";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      loading: true,
      columns: [],
      attData: [],
      selectedSession: null,
      sessions: {},
      selectedStream: null
    };
  },
  computed: {
    ...mapGetters("webcast", {
      webcast: "getCopy"
    }),
    ...mapGetters("registrations", {
      findRegistrationsInStore: "find"
    }),
    ...mapGetters("agg-connections", {
      aggregateConnectionsInStore: "find"
    }),
    ...mapGetters("page-settings", {
      pageSettings: "getCopy"
    })
  },
  methods: {
    ...mapActions("agg-connections", {
      aggregateConnectionsAction: "find"
    }),
    exportTable() {
      this.$refs.table.exportCsv({
        filename: "audio_participants.csv"
      });
    },
    getTableData() {
      this.loading = true;
      this.attData = [];
      this.columns = [];
      let sampleRow = null;

      let query = {
        webcastId: this.webcast._id,
        isAudioParticipants: true
      };

      this.aggregateConnectionsAction({ query: query }).then(resp => {
        if (resp.length <= 0) {
          this.loading = false;
          return;
        }

        console.log(resp);

        this.$data.columns.push(
          {
            title: "Name",
            key: "name",
            align: "left",
            minWidth: 120,
            ellipsis: true
          },
          {
            title: "Notes",
            key: "notes",
            align: "left",
            minWidth: 120,
            ellipsis: true
          },
          {
            title: "Caller Id",
            key: "callerId",
            align: "center",
            minWidth: 120,
            ellipsis: true
          },
          {
            title: "Joined At",
            key: "createdAt",
            align: "center",
            minWidth: 120,
            ellipsis: true
          },
          {
            title: "duration",
            key: "duration",
            align: "center",
            minWidth: 160,
            ellipsis: true
          }
        );

        //this.$data.columns.push({title: 'Duration Check (minutes)', key: 'duration_check', align: 'center', minWidth: 140, ellipsis: true});

        console.log(this.$data.columns);

        let rows = [];
        _.forEach(resp, (row, key) => {
          let rowRecord = {};
          if (row != undefined) {
            if (_.has(row, "attData.info")) {
              _.forEach(row.attData.info, (value, key) => {
                rowRecord[key] = value;
              });
            }

            if (row.attData.info) {
              if (row.attData.info.name) {
                rowRecord["name"] = row.attData.info.name;
              }
              if (row.attData.info.notes) {
                rowRecord["notes"] = row.attData.info.notes;
              }
            }

            rowRecord["duration"] = _.chain(row.duration / 60)
              .toNumber()
              .floor(1);

            rowRecord["callerId"] = row.attData.callerId;

            rowRecord["createdAt"] = moment(row.attData.createdAt).format(
              "HH:mm:ss"
            );

            this.$data.attData.push(rowRecord);
          }
        });

        this.loading = false;
      });
    }
  },
  created() {
    this.$store.commit("session-connections/clearAll");
    this.$store.commit("webcast-session/clearAll");

    this.getTableData();
  },
  mounted() {}
};
</script>
